import { useEffect, useState } from 'react';

import { Form, type FormInstance } from '@arco-design/web-react';

import type { VendorDeviceSelection } from './types';

/**
 * 从 `optionMeta[optionMetaKey]` 恢复计价厂商设备选中态。
 * EBM 用 `ebmNode`，裸金属用 `node`。
 */
export function useOptionMetaVendorDeviceSelection(form: FormInstance, optionMetaKey: string) {
  const optionMeta = Form.useWatch('optionMeta', form) as Record<string, unknown> | undefined;
  const [selection, setSelection] = useState<VendorDeviceSelection | null>(null);

  useEffect(() => {
    const nodeMeta = optionMeta?.[optionMetaKey] as Record<string, unknown> | undefined;
    if (!nodeMeta?.vendorID && !nodeMeta?.vendor && !nodeMeta?.billItemId) {
      setSelection(null);
      return;
    }

    setSelection({
      vendor: nodeMeta.vendor as string | undefined,
      device: nodeMeta.device as string | undefined,
      vendorID: nodeMeta.vendorID as string | undefined,
      deviceID: nodeMeta.deviceID as string | undefined,
      deviceType: nodeMeta.deviceType as string | undefined,
      billItemId: nodeMeta.billItemId as string | undefined,
      detail: nodeMeta.detail as string | undefined,
      quantityUnit: nodeMeta.quantityUnit as string | undefined,
      /** 与列表匹配依赖一致，避免子资源计价项选中后被当成总量价而脱选 */
      useSubResourcePricing: Boolean(nodeMeta.useSubResourcePricing),
    });
  }, [optionMeta, optionMetaKey]);

  return [selection, setSelection] as const;
}
